import axiosInstance from "./axiosInstance";

export async function verifyBrandwacht(userId) {
    const response = await axiosInstance.post('api/verifyBrandwacht', {userId: userId});
    return response;
} 



